export default {
    zh:{
      "invtieText":"邀请",
      "hanleSuc":"邀请成功",
      "searchPolad":"搜索昵称或ID",
      "hanleErr":"邀请失败，请稍后重试",
      "searchText":"搜索",
    },
    ar:{
      "invtieText":"يدعو",
      "hanleSuc":"تمت الدعوة بنجاح",
      "searchPolad":"البحث عن اللقب أو الهوية",
      "hanleErr":"فشلت الدعوة، يرجى المحاولة مرة أخرى لاحقًا",
      "searchText":"يبحث",
    },
    tr:{
      "invtieText":"Davet Et",
      "hanleSuc":"Başarıyla Davet Edildi",
      "searchPolad":"Takma Ad veya Kimliğe Göre Arayın",
      "hanleErr":"Davet başarısız oldu, lütfen daha sonra tekrar deneyin",
      "searchText":"Ara",
    },
    en:{
      "invtieText":"Invite",
      "hanleSuc":"Invite successfully",
      "searchPolad":"Search by nickname or ID",
      "hanleErr":"Invite failed,please try again later",
      "searchText":"Search",
    },
  }
  


// WEBPACK FOOTER //
// src/pages/test/iframe1/lang.js